export const urlFirstPage = ""
export const urlSplashPage = `${urlFirstPage}/welcome`
export const urlNotifPage = `${urlFirstPage}/notifications`
export const urlAwardsPage = `${urlFirstPage}/awards`
export const urlBarcodePage = `${urlFirstPage}/scan-code`
export const urlSupportPage = `${urlFirstPage}/support`
export const urlTopsPage = `${urlFirstPage}/top-customers`
export const urlAddTicketPage = `${urlFirstPage}/support/add`
export const urlChatPage = `${urlFirstPage}/support/detail/chatid`
export const urlNoConnectionPage = `${urlFirstPage}/no-connection`

//host name : change it when host changes
export const HostName = "https://my.paksereshthome.com"

//API path
//secondary path is for login system
const ApiPath = `${HostName}/DesktopModules/WB_CustomersClub_Khaneara/API`
const ApiPathSecondary = `${HostName}/desktopmodules`

//API Urls
export const ApiUrls = {
    //Login
    CheckCode: `${ApiPathSecondary}/wb_login/api/login/CheckCode2`, //POST
    CheckUserName: `${ApiPathSecondary}/wb_login/api/login/CheckUserName2`, //POST
    ChangeName: `${ApiPathSecondary}/wb_login/api/login/ChangeName2`, //POST
    //JWT
    JwtLogin: `${HostName}/API/JwtAuth/mobile/login`,
    JwtExtendtoken: `${HostName}/API/JwtAuth/mobile/extendtoken`,
    //Prize
    GetPrizeForUser: `${ApiPath}/Prize/GetPrizeForUser`, //GET ? orderby
    GetPrize: `${ApiPath}/Prize/GetPrize`, //GET
    RequestPrize: `${ApiPath}/Prize/RequestPrize`, //POST
    //Code
    GetTopUser: `${ApiPath}/Code/GetTopUser`, //GET
    VerifyCode: `${ApiPath}/Code/VerifyCode`, //GET
    SyncScore: `${ApiPath}/Code/SyncScore`, //GET
    //Customer
    GetCustomerInfo: `${ApiPath}/Customer/GetCustomerInfo`, //GET
    //Notification
    GetNotificationByUser: `${ApiPath}/Notification/GetNotificationByUser`, //GET
    SeenNotification: `${ApiPath}/Notification/SeenNotification`, //POST
    //Attach
    UploadAttachment: `${ApiPath}/Ticket/UploadAttachment`, //POST
}